import makeStyles from "@mui/styles/makeStyles";

export const AppPageStyle = makeStyles((theme) => ({
	root: {
		"--home-frost-strong": theme.palette.mode === "light" ? "rgba(255,255,255,0.46)" : "rgba(31,40,54,0.78)",
		"--home-frost-mid": theme.palette.mode === "light" ? "rgba(255,255,255,0.22)" : "rgba(18,26,38,0.56)",
		"--home-frost-soft": theme.palette.mode === "light" ? "rgba(255,255,255,0.12)" : "rgba(8,13,20,0.42)",
		"--home-frost-border": theme.palette.mode === "light" ? "rgba(255,255,255,0.62)" : "rgba(129,212,250,0.18)",
		"--home-frost-border-soft": theme.palette.mode === "light" ? "rgba(255,255,255,0.42)" : "rgba(129,212,250,0.13)",
		"--home-frost-inset": theme.palette.mode === "light" ? "rgba(255,255,255,0.46)" : "rgba(129,212,250,0.08)",
		"--home-frost-inset-soft": theme.palette.mode === "light" ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.24)",
		position: "relative",
		isolation: "isolate",
		minHeight: "100vh",
		width: "100%",
		paddingBottom: theme.spacing(4),
		color: "var(--atl-text)",
		background:
			"linear-gradient(145deg, color-mix(in srgb, var(--atl-cyan) 16%, transparent) 0%, transparent 34%), linear-gradient(215deg, color-mix(in srgb, var(--atl-blue) 12%, transparent) 0%, transparent 42%), linear-gradient(180deg, var(--atl-page-2) 0%, var(--atl-page) 100%)",
		overflowX: "hidden",
		"&:before": {
			content: '""',
			position: "fixed",
			inset: 0,
			zIndex: -2,
			background:
				"linear-gradient(115deg, transparent 0 12%, color-mix(in srgb, var(--atl-cyan) 18%, transparent) 22%, transparent 36% 100%), linear-gradient(68deg, transparent 0 24%, color-mix(in srgb, var(--atl-blue) 12%, transparent) 40%, transparent 58% 100%), linear-gradient(180deg, color-mix(in srgb, var(--atl-teal) 7%, transparent) 0%, transparent 48%)",
			pointerEvents: "none",
		},
		"&:after": {
			content: '""',
			position: "fixed",
			inset: 0,
			zIndex: -1,
			background:
				"repeating-linear-gradient(118deg, transparent 0 22px, color-mix(in srgb, var(--atl-cyan) 9%, transparent) 23px 24px, transparent 25px 74px), repeating-linear-gradient(32deg, transparent 0 34px, color-mix(in srgb, var(--atl-blue) 6%, transparent) 35px 36px, transparent 37px 96px)",
			opacity: 0.55,
			mixBlendMode: theme.palette.mode === "light" ? "multiply" : "screen",
			pointerEvents: "none",
		},
	},
}));
